import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/favicon.png'


const _hoisted_1 = { class: "logo position-absolute start-0 end-0 top-0 bg-black" }
const _hoisted_2 = { class: "sidebar-menu" }
const _hoisted_3 = {
  class: "sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion",
  id: "sidebarNavAccordion"
}
const _hoisted_4 = { class: "sidebar-nav-item" }
const _hoisted_5 = { class: "sidebar-nav-item" }
const _hoisted_6 = { class: "sidebar-nav-item" }
const _hoisted_7 = { class: "sidebar-nav-item" }
const _hoisted_8 = { class: "sidebar-nav-item" }
const _hoisted_9 = { class: "sidebar-nav-item" }
const _hoisted_10 = { class: "sidebar-nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'sidebar-area position-fixed start-0 top-0 bg-black h-100vh transition',
      { active: _ctx.stateStoreInstance.open },
    ]),
      id: "sidebar-area"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "d-flex align-items-center text-white text-decoration-none"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo-icon"
            }, null, -1),
            _createElementVNode("span", { class: "fw-bold ms-10" }, "Hermes", -1)
          ]))]),
          _: 1
        }),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "border-bottom" }, null, -1)),
        _createElementVNode("button", {
          class: "sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "ph-duotone ph-caret-double-right" }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "flaticon-more-1" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Dashboard", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/instalace",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "flaticon-users-group" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Instalace", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/produkty",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "flaticon-3d-cube" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Produkty", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/evidence",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "flaticon-book" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Evidence", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/doklady",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "flaticon-book" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Doklady", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/rawData",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "flaticon-folder" }, null, -1),
                _createElementVNode("span", { class: "title" }, "Nezpracovaná data", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "#",
              class: "sidebar-nav-link d-block"
            }, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-logout" }, null, -1)),
                _createElementVNode("span", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                  class: "title"
                }, "Logout")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_ConfirmModal, { ref: "confirmRef" }, null, 512)
  ], 64))
}